import React, { Fragment, useState } from "react";

import Button from "../../component/button/Button";
import Card from "../../component/card/Card";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import P from "../../component/smallComponents/P";
import Strong from "../../component/smallComponents/Strong";

import CreateModeModal from "./CreateModeModal";
import Starter from "../../component/Starter";

const initialState = {
  modeName: ""
};

const Mode = () => {
  const loginType = localStorage.loginType;
  const [values, setValues] = useState(initialState);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  console.log(loginType);

  return (
    <Starter
      topBarTitle="Modes"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Access Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Modes</a>
          </li>
          <li className="breadcrumb-item active">Modes</li>
        </Fragment>
      }
    >
      <Card>
        <div className="row">
          <div className="col-lg-12">
            <Strong
              title="All inputs are compulsory*"
              className="text-danger float-right"
            />
            <HeaderTag
              type="h4"
              title="Add Modes"
              isClassName={false}
            />
            <P title="Fill the form below to add Add New Modes" />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <Button
              type="button"
              data-toggle="modal"
              title="Create New Modes"
              isBackgroundColor={false}
              data-target="#dark-header-modal"
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark"
            />
          </div>
        </div>
      </Card>

      <CreateModeModal values={values} onChange={handleInputChange} />
      {/* <HeaderTag
              type="h4"
              title="Currently Active"
              isClassName={false}
            />
            <div className="row">{}</div>
            <HeaderTag
              type="h4"
              title="In Active"
              isClassName={false}
            /> */}
      <div className="row">{}</div>
    </Starter>
  );
};

export default Mode;
